// Base UI 1.6 の toast manager は購読者が居ない間の add を捨てる（Provider は effect で購読する）。
// Provider の準備が整うまで貯めて、整ったら順に流す
export function createToastQueue<T>(deliver: (item: T) => void) {
  let isReady = false;
  const pending: T[] = [];
  return {
    enqueue(item: T) {
      if (isReady) deliver(item);
      else pending.push(item);
    },
    ready() {
      if (isReady) return;
      isReady = true;
      pending.splice(0).forEach(item => deliver(item));
    },
    // Provider を描き直す前に呼び、新しい Provider が購読するまで再び貯める。
    // 初回の描画前に貯めた項目は流す対象なので消さない
    reset() {
      isReady = false;
    },
  };
}
